/** 集装箱/柜档案相关类型 */

import type { NodeSubstepKey } from './node-substep';

/** 集装箱类型 */
export enum ContainerType {
  REEFER_20 = 'REEFER_20',
  REEFER_40 = 'REEFER_40',
  DRY_20 = 'DRY_20',
  DRY_40 = 'DRY_40',
}

/** 集装箱状态 */
export enum ContainerStatus {
  AT_ORIGIN = 'AT_ORIGIN',
  IN_TRANSIT = 'IN_TRANSIT',
  AT_CUSTOMS = 'AT_CUSTOMS',
  AT_DESTINATION = 'AT_DESTINATION',
  DELIVERED = 'DELIVERED',
}

/** 节点状态 */
export enum NodeStatus {
  PENDING = 'PENDING',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  ALERT = 'ALERT',
  SKIPPED = 'SKIPPED',
}

/** 地理位置 */
export interface GeoLocation {
  lat: number;
  lng: number;
  portName: string;
  country: string;
}

/** 节点记录 */
export interface NodeRecord {
  nodeId: number;
  nodeName: string;
  status: NodeStatus;
  operatorId: string;
  operatorName: string;
  timestamp: string;
  photos: string[];
  notes: string;
}

/** 节点进度状态（用于UI进度条展示） */
export type NodeProgressStatus = 'done' | 'current' | 'pending' | 'alert';

/** 日志状态 */
export type LogStatus = 'normal' | 'warning' | 'danger';

/** 进度条节点 */
export interface ProgressNode {
  nodeId: number;
  shortName: string;
  fullName: string;
  status: NodeProgressStatus;
}

/** 节点流转日志 */
export interface ContainerArchiveLog {
  id: string;
  containerId: string;
  nodeCode: string;
  timestamp: string;
  operatorName: string;
  nodeName: string;
  description: string;
  logStatus: LogStatus;
}

/** 预警项 */
export interface AlertItem {
  containerNo: string;
  archiveNo: string;
  alertReason: string;
}

/** 预警汇总 */
export interface ContainerAlertSummary {
  count: number;
  items: AlertItem[];
}

/** 集装箱 */
export interface Container {
  id: string;
  containerNo: string;
  orderId: string;
  type: ContainerType;
  sealNo: string;
  currentNode: number;
  totalNodes: number;
  nodeHistory: NodeRecord[];
  iotDeviceId: string;
  temperature: number;
  humidity: number;
  location: GeoLocation;
  status: ContainerStatus;
  vesselName: string;
  voyageNo: string;
  estimatedArrival: string;
  actualArrival: string;
  /** 档案号 */
  archiveNo: string;
  /** 品类 */
  category: string;
  /** 航线 */
  route: string;
  /** 当前节点停留时长 */
  remainingStay: string;
  /**
   * 订舱号 / S-O（与 containerNo 区分）。
   * 订舱阶段(S/O)可先预填，提空柜后柜号再补入同一档案。
   */
  bookingNo?: string;
  /**
   * N4 当前所处子步骤（4.1→4.2→4.3）。仅在 currentNode===4 时有意义。
   */
  currentSubstep?: NodeSubstepKey;
}
